var map = {
	"./Krishna.png": 8891,
	"./Nirav.jpeg": 3121,
	"./aws-certified-cloud-practitioner.png": 6664,
	"./dev.png": 5815,
	"./inf.jpeg": 502,
	"./jlpt.png": 1018,
	"./la.png": 5719,
	"./mefgi.png": 7930,
	"./so.ico": 5646,
	"./tripla.png": 3742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1106;